import React from "react";
import {
  FaHotel,
  FaUmbrellaBeach,
  FaPlane,
  FaFileSignature,
  FaClipboardList,
  FaChartLine,
  FaUserFriends,
  FaLayerGroup,
} from "react-icons/fa";
import { agentValueItems } from "./landingContent";

const ICONS = {
  hotels: FaHotel,
  packages: FaUmbrellaBeach,
  flights: FaPlane,
  quotes: FaFileSignature,
  orders: FaClipboardList,
  finance: FaChartLine,
  clients: FaUserFriends,
  onePlace: FaLayerGroup,
};

export default function LandingAgentValue() {
  return (
    <section
      className="hr-landing-section hr-landing-section--muted"
      aria-labelledby="hr-landing-value-title"
    >
      <div className="home-page__container">
        <header className="hr-landing-section__head">
          <h2 id="hr-landing-value-title" className="hr-landing-section__title">
            מה הסוכן מקבל בפועל
          </h2>
          <p className="hr-landing-section__lead">
            לא רשימת פיצ׳רים גנרית — אלא השכבות שמרכיבות את יום העבודה במערכת HotelsRiver.
          </p>
        </header>
        <ul className="hr-landing-value-grid">
          {agentValueItems.map((item) => {
            const Icon = ICONS[item.id] || FaLayerGroup;
            return (
              <li key={item.id} className="hr-landing-value-card">
                <span className="hr-landing-value-card__icon" aria-hidden>
                  <Icon />
                </span>
                <h3 className="hr-landing-value-card__title">{item.title}</h3>
                <p className="hr-landing-value-card__text">{item.text}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
